import { environment } from 'src/environments/environment';

export const URLS = {
  baseAddressUrl: `${environment.addressHostName}/`,
  baseApiHostUrl: `${environment.apiHostName}/`,
  addressUrl: {
    endpoint: `search.php`,
  },
  AI: {
    endpoint: 'api/AI/',
    methods: {
      GetCsvFromStoredProcedure: 'GetCsvFromStoredProcedure',
      GetCsvFromTotalEmissionCatWise: 'GetCsvFromTotalEmissionCatWise',
      GetCsvForMAReport: 'GetCsvForMAReport',
      GetCsvFromGhgEmissionScopeWise: 'GetCsvFromGhgEmissionScopeWise',
      GetCsvFromGhgEmissionPeriodAndLocationWise:
        'GetCsvFromGhgEmissionPeriodAndLocationWise',
      GetAIReportDataWithLastAndSeconLastYearDataAsync:
        'GetAIReportDataWithLastAndSeconLastYearDataAsync',
    },
  },
  Benchmarking: {
    endpoint: 'Benchmarking/',
    methods: {
      GetAllLocationByUserId: 'GetAllLocationByUserId',
      GetAllPreviousYear: 'GetAllPreviousYear',
      AddYear: 'AddYear',
      GetAllBranchMarkingList: 'GetAllBranchMarkingList',
      GetAllUnitMaster: 'GetAllUnitMaster',
      GetAllBenchMarkingStandards: 'GetAllBenchMarkingStandards',
      GetAllCurrencyMaster: 'GetAllCurrencyMaster',
      GetInternalBranchMarkingDetailsById:
        'GetInternalBranchMarkingDetailsById',
      AddOrUpdateInternalBranchMarking: 'AddOrUpdateInternalBranchMarking',
      GetAllBranchMarkingListByYearAndLocation:
        'GetAllBranchMarkingListByYearAndLocation',
      ApprovedBenchMarking: 'ApprovedBenchMarking',
      siteOfficeComparisonAsync: 'siteOfficeComparisonAsync',
      SetAsBenchMark: 'SetAsBenchMark',
    },
  },
  BoardStructureAndFinancialData: {
    endpoint: 'BoardStructureAndFinancialData/',
    methods: {
      GetAllBoardStructureAndFinancialData:
        'GetAllBoardStructureAndFinancialData',
      GetBoardStructureAndFinancialData: 'GetBoardStructureAndFinancialData',
      AddOrUpdateBoardStructureAndFinancialData:
        'AddOrUpdateBoardStructureAndFinancialData',
      DeleteBoardDetails: 'DeleteBoardDetails',
      DeleteDisclosureAndRiskLinage: 'DeleteDisclosureAndRiskLinage',
      DeleteBoardDetailsOversight: 'DeleteBoardDetailsOversight',
    },
  },
  BiodiverstyandEcoSystem: {
    endpoint: 'BiodiverstyandEcoSystem/',
    methods: {
      GetAllBiodiversityProtectionMeasures:
        'GetAllBiodiversityProtectionMeasures',
      GetAllBiodiversityHabitatTypes: 'GetAllBiodiversityHabitatTypes',
      AddOrUpdateBioDiversityDetails: 'AddOrUpdateBioDiversityDetails',
      getBiodiversityByIds: 'getBiodiversityByIds',
      DeleteBioDiversityDocument: 'DeleteBioDiversityDocument',
    },
  },
  CBAM: {
    endpoint: 'api/CBAM/',
    methods: {
      GetDashboardData: 'GetDashboardData',
      GetEmissionSummary: 'GetEmissionSummary',
      GetCBAMDocumentsType: 'GetCBAMDocumentsType',
      GetAllProcessMaterials: 'GetAllProcessMaterials',
      GetAllElectricitySources: 'GetAllElectricitySources',
      GetAllElectricitySourceTypes: 'GetAllElectricitySourceTypes',
      AddOrUpdateMassBalance: 'AddOrUpdateMassBalance',
      CalculateEmission: 'CalculateEmission',
      GetMassBalanceByProductId: 'GetMassBalanceByProductId',
      AddOrUpdateElectricityConsumption: 'AddOrUpdateElectricityConsumption',
      GetElectricityConsumptionByProductId:
        'GetElectricityConsumptionByProductId',
      DeleteMassBalance: 'DeleteMassBalance',
      DeleteElectricityConsumption: 'DeleteElectricityConsumption',
      UploadCBAMEmissionDocument: 'UploadCBAMEmissionDocument',
      GetCBAMEmissionDocuments: 'GetCBAMEmissionDocuments',
      DeleteCBAMDocument: 'DeleteCBAMDocument',
      GetAllSector: 'GetAllSector',
      GetCNBySector: 'GetCNBySector',
      GetAllCategories: 'GetAllCategories',
      AddCategory: 'AddCategory',
      AddRoute: 'AddRoute',
      AddFuel: 'AddFuel',
      GetRoutesByCategoryId: 'GetRoutesByCategoryId',
      GetFuelType: 'GetFuelType',
      GetFuel: 'GetFuel',
      AddOrUpdateCombustion: 'AddOrUpdateCombustion',
      DeleteCombustion: 'DeleteCombustion',
      GetCombustionByProductId: 'GetCombustionByProductId',
      GetAllDataQualityOptions: 'GetAllDataQualityOptions',
      GetAllDefaultValueJustifications: 'GetAllDefaultValueJustifications',
      GetAllInformationQualityAssurance: 'GetAllInformationQualityAssurance',
      AddOrUpdateProcessEmission: 'AddOrUpdateProcessEmission',
      DeleteProcessEmission: 'DeleteProcessEmission',
      GetProcessEmissionByProductId: 'GetProcessEmissionByProductId',
      DeletePurchasedPrecursor: 'DeletePurchasedPrecursor',
      AddOrUpdatePurchasedPrecursor: 'AddOrUpdatePurchasedPrecursor',
      GetAllPrecursor: 'GetAllPrecursor',
      AddPrecursor: 'AddPrecursor',
      GetPurchasedPrecursorByProductId: 'GetPurchasedPrecursorByProductId',
      GetAllCBAMEmission: 'GetAllCBAMEmission',
      DownloadCBAMEmission: 'DownloadCBAMEmission',
      DownloadExcelTemplateCBAM: 'DownloadExcelTemplateCBAM',
      FinalizeProduct: 'FinalizeProduct',
      AddProcessMaterial: 'AddProcessMaterial',
      GetSourceOfEmissionFactors: 'GetSourceOfEmissionFactors',
      GetAllSpecificDirectEmissionSources:
        'GetAllSpecificDirectEmissionSources',
      GetDefaultValueJustifications: 'GetDefaultValueJustifications',
    },
  },
  CommunityEngagement: {
    endpoint: 'api/CommunityEngagement/',
    methods: {
      AddKeySocialProgram: 'AddKeySocialProgram',
      GetAllKeySocialProgram: 'GetAllKeySocialProgram',
      AddStakeholderEngagement: 'AddStakeholderEngagement',
      GetAllStakeholderEngagement: 'GetAllStakeholderEngagement',
      AddSocialEnvironmentalRisk: 'AddSocialEnvironmentalRisk',
      GetAllSocialEnvironmentalRisks: 'GetAllSocialEnvironmentalRisks',
      AddOrUpdateCommunityEngagement: 'AddOrUpdateCommunityEngagement',
      GetCommunityEngagement: 'GetCommunityEngagement',
      GetCSRInformationByReportingYear: 'GetCSRInformationByReportingYear',
      AddOrUpdateCSRInformation: 'AddOrUpdateCSRInformation',
      DeleteCSRInformationDocument: 'DeleteCSRInformationDocument',
      GetCSRFundAndTransfer: 'GetCSRFundAndTransfer',
      AddOrUpdateCSRFundAndTransfer: 'AddOrUpdateCSRFundAndTransfer',
      GetCSRProjectListByReportingYear: 'GetCSRProjectListByReportingYear',
      GetCSRProjectById: 'GetCSRProjectById',
      AddOrUpdateCSRProject: 'AddOrUpdateCSRProject',
    },
  },
  ContactPerson: {
    endpoint: 'ContactPerson/',
    methods: {
      CheckContactPersonEmailExistence: 'CheckContactPersonEmailExistence',
      CheckContactPersonExistenceByContactNo:
        'CheckContactPersonExistenceByContactNo',
    },
  },
  CorporateOfficeMaster: {
    endpoint: 'CorporateOfficeMaster/',
    methods: {
      GetAllCorporateOfficeMasters: 'GetAllCorporateOfficeMasters',
      GetCorporateOfficeMasterById: 'GetCorporateOfficeMasterById',
      AddCorporateOfficeMaster: 'AddCorporateOfficeMaster',
      UpdateCorporateOfficeMaster: 'UpdateCorporateOfficeMaster',
      DeleteOfficeContactPerson: 'DeleteOfficeContactPerson',
      CalculateProfileCompletionPercentage:
        'CalculateProfileCompletionPercentage',
      GetCorporateOfficeDropdown: 'GetCorporateOfficeDropdown',
      GetAllOfficeDetail: 'GetAllOfficeDetail',
    },
  },
  CustomerHealthandSafety: {
    endpoint: 'api/CustomerHealthandSafety/',
    methods: {
      GetProductMaster: 'GetProductMaster',
      GetTrainingProgramMaster: 'GetTrainingProgramMaster',
      GetTrainingTypeMaster: 'GetTrainingTypeMaster',
      GetCustomerHealthandSafetyDetails: 'GetCustomerHealthandSafetyDetails',
      AddOrUpdateCustomerHealthandSafetyDetails:
        'AddOrUpdateCustomerHealthandSafetyDetails',
      GetAllCustomerHealthandSafety: 'GetAllCustomerHealthandSafety',
      DeleteProductDetails: 'DeleteProductDetails',
      DeleteNonComplianceIncidencesDetails:
        'DeleteNonComplianceIncidencesDetails',
      DeleteRecallDetails: 'DeleteRecallDetails',
      DeleteAssesementDetails: 'DeleteAssesementDetails',
      DeleteCHSTrainingDetails: 'DeleteCHSTrainingDetails',
      DeleteEvidenceDocument: 'DeleteEvidenceDocument',
      DeleteFinesAndPenalties: 'DeleteFinesAndPenalties',
      GetProductRecallTypeMaster: 'GetProductRecallTypeMaster',
    },
  },
  DEIAndHumanRights: {
    endpoint: 'DEIAndHumanRights/',
    methods: {
      GetAllDiscriminationType: 'GetAllDiscriminationType',
      AddDiscriminationType: 'AddDiscriminationType',
      GetDEIAndHumanRightList: 'GetDEIAndHumanRightList',
      AddOrUpdateDiversityEquityInclusion:
        'AddOrUpdateDiversityEquityInclusion',
      AddOrUpdateLabourAndHumanRights: 'AddOrUpdateLabourAndHumanRights',
      GetDiversityEquityInclusion: 'GetDiversityEquityInclusion',
      GetLabourAndHumanRights: 'GetLabourAndHumanRights',
      DeleteDEIHumanRightsDocument: 'DeleteDEIHumanRightsDocument',
      GetEmployees: 'GetEmployees',
    },
  },
  DepartmentMaster: {
    endpoint: 'DepartmentMaster/',
    methods: {
      GetAllDepartmentMasters: 'GetAllDepartmentMasters',
      GetAllDepartmentMasterById: 'GetAllDepartmentMasterById',
      AddDepartmentMaster: 'AddDepartmentMaster',
      UpdateDepartmentMaster: 'UpdateDepartmentMaster',
    },
  },
  DesignationMaster: {
    endpoint: 'DesignationMaster/',
    methods: {
      GetAllDesignationMasters: 'GetAllDesignationMasters',
      GetDesignationMasterById: 'GetDesignationMasterById',
      AddDesignationMaster: 'AddDesignationMaster',
      UpdateDesignationMaster: 'UpdateDesignationMaster',
    },
  },
  DropdownType: {
    endpoint: 'DropdownType/',
    methods: {
      GetAllDropdownTypeMaster: 'GetAllDropdownTypeMaster',
      GetAllDropdownItem: 'GetAllDropdownItem',
      GetDropdownType: 'GetDropdownType',
      GetDropdownitem: 'GetDropdownitem',
    },
  },
  EHS: {
    endpoint: 'api/EHS/',
    methods: {
      GetAllEHSEmployeeTypeMaster: 'GetAllEHSEmployeeTypeMaster',
      GetAllEhsIncidentTypeMaster: 'GetAllEhsIncidentTypeMaster',
      GetAllEhsMedicalSupportMaster: 'GetAllEhsMedicalSupportMaster',
      GetAllEhsResolutionStatusMaster: 'GetAllEhsResolutionStatusMaster',
      GetAllEhsSeverityLevelMaster: 'GetAllEhsSeverityLevelMaster',
      GetAllEhsStressLevelRatingMaster: 'GetAllEhsStressLevelRatingMaster',
      GetAllEhsWorkLifeBalanceRatingMaster:
        'GetAllEhsWorkLifeBalanceRatingMaster',
      GetAllEhsInformationListEmployees: 'GetAllEhsInformationListEmployees',
      GetEhsInfromationEployeeById: 'GetEhsInfromationEployeeById',
      AddOrUpdateEmployes: 'AddOrUpdateEmployes',
      AddOrUpdateEmployesEHSData: 'AddOrUpdateEmployesEHSData',
      DeleteMentalHealthAndWellbeingDocument:
        'DeleteMentalHealthAndWellbeingDocument',
      DeletePhysicalHealthAndMedicalDocument:
        'DeletePhysicalHealthAndMedicalDocument',
      DownloadtExcelTemplateEHSEmployee: 'DownloadtExcelTemplateEHSEmployee',
      UploadExcelForEHSEmployee: 'UploadExcelForEHSEmployee',
    },
  },
  EnergyManagement: {
    endpoint: 'EnergyManagement/',
    methods: {
      GetEnergyData: 'GetEnergyData',
      AddOrUpdateEnergyManagement: 'AddOrUpdateEnergyManagement',
      DeleteEnergyManagementDocument: 'DeleteEnergyManagementDocument',
      DeleteEnergyManagementSingleDocument:
        'DeleteEnergyManagementSingleDocument',
      GetAllEnergyRegulatoryComplianceMaster:
        'GetAllEnergyRegulatoryComplianceMaster',
      GetAllEnergyCategoryMaster: 'GetAllEnergyCategoryMaster',
      GetAllEnergySubCategoryMaster: 'GetAllEnergySubCategoryMaster',
      AddOrUpdateEnergyManagementDocument:
        'AddOrUpdateEnergyManagementDocument',
      GetEnergySavingTrendsData: 'GetEnergySavingTrendsData',
    },
  },
  EnvironmentDashboard: {
    endpoint: 'api/EnvironmentDashboard/',
    methods: {
      GetCarbonEmissionData: 'GetCarbonEmissionData',
      GetEnergyConsumptionData: 'GetEnergyConsumptionData',
      GetEnergyConsumptionDataByQuarterly:
        'GetEnergyConsumptionDataByQuarterly',
      GetWaterConsumptionData: 'GetWaterConsumptionData',
      GetWaterConsumptionDataByQuarterly: 'GetWaterConsumptionDataByQuarterly',
      GetEnvironmentWasteConsumptionData: 'GetEnvironmentWasteConsumptionData',
      GetEnvironmentWasteConsumptionDataByQuarterly:
        'GetEnvironmentWasteConsumptionDataByQuarterly',
    },
  },
  EmployeeSatisfactionAndRetention: {
    endpoint: 'EmployeeSatisfactionAndRetention/',
    methods: {
      GetAllAudienceMaster: 'GetAllAudienceMaster',
      GetAllChannelMaster: 'GetAllChannelMaster',
      GetAllProgramMaster: 'GetAllProgramMaster',
      GetAllPostRetirementMaster: 'GetAllPostRetirementMaster',
      GetEmployeeSatisfaction: 'GetEmployeeSatisfaction',
      AddOrUpdateEmployeeSatisfaction: 'AddOrUpdateEmployeeSatisfaction',
      UploadFeedbackDocs: 'UploadFeedbackDocs',
      GetAllEmployeeSatisfactionAndRetention:
        'GetAllEmployeeSatisfactionAndRetention',
      DeleteFeedbackDocument: 'DeleteFeedbackDocument',
      DeleteSurveyDetails: 'DeleteSurveyDetails',
      DeleteWellbeingDetails: 'DeleteWellbeingDetails',
      DeleteCompliantDetails: 'DeleteCompliantDetails',
      GetAllGrievanceType: 'GetAllGrievanceType',
      AddGrievanceType: 'AddGrievanceType',
    },
  },

  BusinessEthicsAndAntiCorruption: {
    endpoint: 'BusinessEthicsAndAntiCorruption/',
    methods: {
      GetAllBusinessEthicsDetails: 'GetAllBusinessEthicsDetails',
      AddOrUpdateBusinessEthicsDetails: 'AddOrUpdateBusinessEthicsDetails',

      GetAllGrievanceTypes: 'GetAllGrievanceTypes',
      GetBusinessEthicsSubjectToFineMaster:
        'GetBusinessEthicsSubjectToFineMaster',
      GetBusinessEthicsPenaltiesMaster: 'GetBusinessEthicsPenaltiesMaster',

      GetBusinessEthicsYearDetails: 'GetBusinessEthicsYearDetails',

      DeleteBusinessEthicsDocuments: 'DeleteBusinessEthicsDocuments',
      UploadBusinessEthicsDocuments: 'UploadBusinessEthicsDocuments',
      AddBusinessEthicsAntiCorruptionRiskDocumentResDTO:
        'AddBusinessEthicsAntiCorruptionRiskDocumentResDTO',
      AddBusinessEthicsAntiCorruptionEvidenceDocument:
        'AddBusinessEthicsAntiCorruptionEvidenceDocument',
      DeleteRegulatorySectionDetails: 'DeleteRegulatorySectionDetails',
      DeleteGrievanceRegisterDetails: 'DeleteGrievanceRegisterDetails',

      DeleteRiskAssessmentDocument: 'DeleteRiskAssessmentDocument',
      DeleteEvidenceDocument: 'DeleteEvidenceDocument',
      GetPenaltiesAndSanctions: 'GetPenaltiesAndSanctions',
    },
  },

  DataProtectionAndCyberSecurity: {
    endpoint: 'api/DataProtectionAndCyberSecurity/',
    methods: {
      GetDataProtectionCyberSecurityByReportingYear:
        'GetDataProtectionCyberSecurityByReportingYear',
      AddOrUpdateDataProtectionCyberSecurity:
        'AddOrUpdateDataProtectionCyberSecurity',

      GetAllDataProtectionLawMasters: 'GetAllDataProtectionLawMasters',
      GetAllDataProtectionCyberSecurityTypeOfIncident:
        'GetAllDataProtectionCyberSecurityTypeOfIncident',
      AddDataProtectionLawMasters: 'AddDataProtectionLawMasters',

      GetDataProtectionCyberSecurityDocuments:
        'GetDataProtectionCyberSecurityDocuments',
      UploadDataProtectionCyberSecurityDocument:
        'UploadDataProtectionCyberSecurityDocument',
      DeleteDataProtectionCyberSecurityDocument:
        'DeleteDataProtectionCyberSecurityDocument',

      GetEmployeeTrainedByReportingYear: 'GetEmployeeTrainedByReportingYear',
      DeleteEmployeeTrainingVisibility: 'DeleteEmployeeTrainingVisibility',

      GetPolicyDocumentsByReportingYear: 'GetPolicyDocumentsByReportingYear',
      DeletePolicyDocumentVisibility: 'DeletePolicyDocumentVisibility',

      GetAllDataProtectionCyberSecurityDetails:
        'GetAllDataProtectionCyberSecurityDetails',
      GetOrganizationNameForDataProtection:
        'GetOrganizationNameForDataProtection',
    },
  },

  RiskAssessment: {
    endpoint: 'api/RiskAssessment/',
    methods: {
      GetAllRiskAssessmentRegulatoryComplianceDetails:
        'GetAllRiskAssessmentRegulatoryComplianceDetails',
      GetRiskAssessmentRegulatoryCompliance:
        'GetRiskAssessmentRegulatoryCompliance',
      AddOrUpdateRiskAssessmentRegulatoryCompliance:
        'AddOrUpdateRiskAssessmentRegulatoryCompliance',
    },
  },

  GHG: {
    endpoint: 'GHG/',
    methods: {
      GetGHGItemsByDCFGroupId: 'GetGHGItemsByDCFGroupId',
      GetGHGItemsByDCFGroupIdScope3: 'GetGHGItemsByDCFGroupIdScope3',
      DeleteGHGItem: 'DeleteGHGItem',
      DeleteGHGItemScope3: 'DeleteGHGItemScope3',
      AddUpdateGHGItemsByDCFGroupId: 'AddUpdateGHGItemsByDCFGroupId',
      AddUpdateGHGItemsByDCFGroupIdScope3:
        'AddUpdateGHGItemsByDCFGroupIdScope3',
      GetFactor: 'GetFactor',
      CalculateEmissions: 'CalculateEmissions',
      GetUnitByDropdownItemID: 'GetUnitByDropdownItemID',
      CountOfGHGPendingApproval: 'CountOfGHGPendingApproval',
      AddSupplierlist: 'AddSupplierlist',
      GetAllSupplierList: 'GetAllSupplierList',
      GetAllGHGEmissionEmplyoee: 'GetAllGHGEmissionEmplyoee',
      GetAllSubDropdownItems: 'GetAllSubDropdownItems',
      GetAllGhgemissionSource: 'GetAllGhgemissionSource',
      GetAllGHGEmissionSoldProduct: 'GetAllGHGEmissionSoldProduct',
      GetAllGHGEmissionFranchise: 'GetAllGHGEmissionFranchise',
      GetAllGHGEmissionInvestmentPortfolio:
        'GetAllGHGEmissionInvestmentPortfolio',
      UploadEmployeeExcelData: 'UploadEmployeeExcelData',
      ExtactExcelDataForSoldProduct: 'ExtactExcelDataForSoldProduct',
      ExtactExcelForGHGEmissionInvestmentPortfolio:
        'ExtactExcelForGHGEmissionInvestmentPortfolio',
      ExtactExcelForGHGEmissionFrenchise: 'ExtactExcelForGHGEmissionFrenchise',
      ExtactExcelForGhgemissionLeasedAsset:
        'ExtactExcelForGhgemissionLeasedAsset',
      DownloadEmployeeExcelTemplate: 'DownloadEmployeeExcelTemplate',
      DownloadSoldProductExcelTemplate: 'DownloadSoldProductExcelTemplate',
      DownloadInvestmentPortfolioExcelTemplate:
        'DownloadInvestmentPortfolioExcelTemplate',
      DownloadFrenchiseExcelTemplate: 'DownloadFrenchiseExcelTemplate',
      DownloadLeasedAssetExcelTemplate: 'DownloadLeasedAssetExcelTemplate',
      AddGHGEmissionSoldProduct: 'AddGHGEmissionSoldProduct',
      AddGHGEmissionInvestmentPortfolio: 'AddGHGEmissionInvestmentPortfolio',
      AddGHGEmissionFrenchise: 'AddGHGEmissionFrenchise',
      AddGhgemissionLeasedAsset: 'AddGhgemissionLeasedAsset',
      GetAllGHGEmissionLeasedAsset: 'GetAllGHGEmissionLeasedAsset',
      GetAllGHGEmissionWorkArrangement: 'GetAllGHGEmissionWorkArrangement',
      GetMajorContributorInGHGEmission: 'GetMajorContributorInGHGEmission',
      DownloadtExcelTemplateCategory1and2:
        'DownloadtExcelTemplateCategory1and2',
      DownloadtExcelTemplateCategory1: 'DownloadtExcelTemplateCategory1',
      DownloadtExcelTemplateCategory2: 'DownloadtExcelTemplateCategory2',
      DownloadtExcelTemplateCategory6: 'DownloadtExcelTemplateCategory6',
      DownloadtExcelTemplateCategory7: 'DownloadtExcelTemplateCategory7',
      UploadExcelForGHGEmissionCatgeory1and2:
        'UploadExcelForGHGEmissionCatgeory1and2',
      UploadExcelForGHGEmissionCatgeory6: 'UploadExcelForGHGEmissionCatgeory6',
      UploadExcelForGHGEmissionCatgeory7: 'UploadExcelForGHGEmissionCatgeory7',
      GHGEmissionDataBatchHistoryByBatchId:
        'GHGEmissionDataBatchHistoryByBatchId',
      GetInventory: 'GetInventory',
      GetEvidenceDocumentDataAsync: 'GetEvidenceDocumentDataAsync',
      DeleteEvidenceDocumentDataAsync: 'DeleteEvidenceDocumentDataAsync',
      AddEvidenceDocument: 'AddEvidenceDocument',
      AddGHGEmissionEmplyoee: 'AddGHGEmissionEmplyoee',
      GetTotalghgEmission: 'GetTotalghgEmission',
      AddFactor: 'AddFactor',
      UpdateFactor: 'UpdateFactor',
      GetListFactor: 'GetListFactor',
    },
  },
  GHGAvoidance: {
    endpoint: 'GHGAvoidance/',
    methods: {
      GetAllGhgavoidanceCategory: 'GetAllGhgavoidanceCategory',
      GetGhgavoidanceDropdowntype: 'GetGhgavoidanceDropdowntype',
      GetAllGHGAvoidanceDisplacementConfig:
        'GetAllGHGAvoidanceDisplacementConfig',
      GetAllGHGAvoidanceFuel: 'GetAllGHGAvoidanceFuel',
      GetAllGHGAvoidanceFuelType: 'GetAllGHGAvoidanceFuelType',
      AddGHGAvoidanceDisplacementConfig: 'AddGHGAvoidanceDisplacementConfig',
      GetGHGAvoidanceDisplacementConfigByGroupId:
        'GetGHGAvoidanceDisplacementConfigByGroupId',
      GetGHGItemsByDCFGroupId: 'GetGHGItemsByDCFGroupId',
      DeleteGHGItem: 'DeleteGHGItem',
      GHGAvoidanceUnit: 'GHGAvoidanceUnit',
      AddUpdateGHGItemsByDCFGroupId: 'AddUpdateGHGItemsByDCFGroupId',
      GetGhgAvoidanceCalculation: 'GetGhgAvoidanceCalculation',
      GHGAvoidanceDataBatchHistoryByBatchId:
        'GHGAvoidanceDataBatchHistoryByBatchId',
    },
  },
  GHGOffsetNetZero: {
    endpoint: 'GHGOffsetNetZero/',
    methods: {
      GetAllGhgOffsetMethodMasters: 'GetAllGhgoffsetMethodMasters',
      GetAllGhgOffGoalType: 'GetAllGhgoffGoleType',
      GetAllGhgOffsetCurrencyMaster: 'GetAllGhgoffsetCurrencyMaster',
      GetAllBaselinePeriod: 'GetAllBaselinePeriod',
      GetALLNetZeroStrategies: 'GetALLNetZeroStategyies',
      GetTargetSettings: 'GetTargetSettings',
      GetGHGReductionTargets: 'GetGHGReductionTargets',
      GetAllGhgoffsetCurrencyMaster: 'GetAllGhgoffsetCurrencyMaster',
      CalculateReductionTargetValue: 'CalculateReductionTargetValue',
      GetNetZeroStrategiesById: 'GetNetZeroStrategiesById',
      GetAllEmissionSummary: 'GetAllEmissionSummary',
      GetCalculationHistory: 'GetCalculationHistory',
      SetBaselinePeriod: 'SetBaselinePeriod',
      CalculateProjectEmissionByGoalTypeId:
        'CalculateProjectEmissionByGoalTypeId',
      GHGOffSetGetGoalTrackingHeader: 'GHGOffSetGetGoalTrackingHeader',
      GetAllTrackingFrequency: 'GetAllTrackingFrequency',
      GetAllCategoryByModuleAndSubModuleId:
        'GetAllCategoryByModuleandSubModuleId',
      SetTargetSettings: 'SetTargetSettings',
      GHGOffSetGetGoalTrackingScopeWise: 'GHGOffSetGetGoalTrackingScopeWise',
      GHGOffSetGetGoalTrackingEstimationScopeWise:
        'GHGOffSetGetGoalTrackingEstimationScopeWise',
      GHGOffSetGetGoalTrackingCategoryWise:
        'GHGOffSetGetGoalTrackingCategoryWise',
      GHGOffSetGetGoalTrackingEstimationCategoryWise:
        'GHGOffSetGetGoalTrackingEstimationCategoryWise',
      GetReductionTargetForAllScopesAndCategories:
        'GetReductionTargetForAllScopesAndCategories',
      GetBaselineyear: 'GetBaselineyear',
      GetEmissionsByCoverageAndGoalType: 'GetEmissionsByCoverageAndGoalType',
      GetAllAlignmentMaster: 'GetAllAlignmentMaster',
      AddOrUpdateTargetSetting: 'AddOrUpdateTargetSetting',
      CalculateReductionTarget: 'CalculateReductionTarget',
      CheckPrimaryStatus: 'CheckPrimaryStatus',
      GetTargetSettingDataById: 'GetTargetSettingDataById',
      GetAllGoalSettingandTrackngTableData:
        'GetAllGoalSettingandTrackngTableData',
      AddGhgOffsetAlignmentAsync: 'AddGhgOffsetAlignmentAsync',
      CalculateTargetandProjectedEmission:
        'CalculateTargetandProjectedEmission',
      GetBaselineGoalSettingandTrackingTableData:
        'GetBaselineGoalSettingandTrackingTableData',
      GetGraphDatabyScopeId: 'GetGraphDatabyScopeId',
    },
  },
  GoalSettingandTracking: {
    endpoint: 'API/GoalSettingandTracking/',
    methods: {
      GetBaselineYear: 'GetBaselineYear',
      GetCCTSYear: 'GetCCTSYear',
      GetAllEmissionSummaryforBaseline: 'GetAllEmissionSummaryForBaseline',
      GetAllEmissionSummaryforCCTS: 'GetAllEmissionSummaryForCCTS',
      GetCalculationHistory: 'GetCalculationHistory',
      SetBaselinePeriod: 'SetBaselinePeriod',
      GoalSettingandTrackingGoalTypeMaster:
        'GoalSettingandTrackingGoalTypeMaster',
      GoalSettingandTrackingAlignmentMaster:
        'GoalSettingandTrackingAlignmentMaster',
      AddGoalSettingandTrackingAlignmentMasterAsync:
        'AddGoalSettingandTrackingAlignmentMasterAsync',
      GoalSettingandTrackingMethodMaster: 'GoalSettingandTrackingMethodMaster',
      GetAllGoalSettingandTrackingCurrencyMaster:
        'GetAllGoalSettingandTrackingCurrencyMaster',
      GetAllGoalSettingandTrackingTargetData:
        'GetAllGoalSettingandTrackingTargetData',
      GetAllGoalSettingandTrackingBaselineTargets:
        'GetAllGoalSettingandTrackingBaselineTargets',
      GetBaslineOrCCTSEmissionByCoverage: 'GetBaslineOrCCTSEmissionsByCoverage',
      CalculateReductionTargetValue: 'CalculateReductionTargetValue',
      GoalSettingandTrackingTargetDatabyId:
        'GoalSettingandTrackingTargetDatabyId',
      AddOrUpdateTargetSetting: 'AddOrUpdateTargetSetting',
      GetGoalSettingandTrackingTableData: 'GetGoalSettingandTrackingTableData',
      GetAllCategoryByModuleAndSubModuleId:
        'GetAllCategoryByModuleandSubModuleId',
    },
  },
  GHGAvoidanceAndRemovalStrategy: {
    endpoint: 'GHGAvoidanceAndRemovalStrategy/',
    methods: {
      GetAllAvoidanceMethod: 'GetAllAvoidanceMethod',
      GetAllAvoidanceApproach: 'GetAllAvoidanceApproach',
      GetAllAvoidanceActivities: 'GetAllAvoidanceActivities',
      GetIdentificationOfEmissionSource: 'GetIdentificationOfEmissionSource',
      GetAvoidanceAndRemovalStrategy: 'GetAvoidanceAndRemovalStrategy',
      AvoidanceAndRemovalStrategyUpdate: 'AvoidanceAndRemovalStrategyUpdate',
      IdentificationOfEmissionSourceNext: 'IdentificationOfEmissionSourceNext',
      GetALLNetZeroStategyies: 'GetALLNetZeroStategyies',
      AddAvoidanceAndRemovalStrategy: 'AddAvoidanceAndRemovalStrategy',
      GetALLAvoidanceAndRemovalStrategy: 'GetALLAvoidanceAndRemovalStrategy',
      GetAvoidanceandRemovalEmissionDataHistory:
        'GetAvoidanceandRemovalEmissionDataHistory',
      AddAvoidanceApproach: 'AddAvoidanceApproach',
      AddAvoidanceAndRemovalActivityMaster:
        'AddAvoidanceAndRemovalActivityMaster',
      GetAvoidanceandRemovalTableData: 'GetAvoidanceandRemovalTableData',
      AddAvoidanceDocument: 'AddAvoidanceDocument',
      DeleteAvoidanceDocument: 'DeleteAvoidanceDocument',
      GetAvoidanceDocumentByEmissionId: 'getAvoidanceDocumentByEmissionId',
      DownloadAvoidanceAndRemovalDocument:
        'DownloadAvoidanceAndRemovalDocument',
    },
  },
  inventorization: {
    endpoint: 'Inventorization/',
    methods: {
      AddInventorization: 'AddInventorization',
      GetInventrizationList: 'GetInventrizationList',
      AddInventorizationLocationMapp: 'AddInventorizationLocationMapp',
      GetLocationMappingList: 'GetLocationMappingList',
      GetAllOffices: 'GetAllOffices',
      GetEmissonSourceList: 'GetEmissonSourceList',
      UpdateInventoryLocation: 'UpdateInventoryLocation',
      GetBoundary: 'GetBoundary',
      DownloadInventoryTemplate: 'DownloadInventoryTemplate',
      UploadExcelForInventory: 'UploadExcelForInventory',
      UpdateInventorization: 'UpdateInventorization',
      GetInventoryById: 'GetInventoryById',
      GetInventoryLocationById: 'GetInventoryLocationById',
      UpdateInventoryById: 'UpdateInventoryById',
      GetCorporateOfficeIndustryType: 'GetCorporateOfficeIndustryType',
    },
  },
  Logging: {
    endpoint: 'api/Logging/',
    methods: {
      GetCurrentLogLevel: 'GetCurrentLogLevel',
      GetDefaultLogLevel: 'GetDefaultLogLevel',
      ChangeLogLevel: 'ChangeLogLevel',
    },
  },
  login: {
    endpoint: 'Login/',
    methods: {
      userLogin: 'api/userlogin',
      refreshToken: 'api/refresh-token',
      logout: 'api/logout',
      resetUserPassword: 'ResetUserPassword',
      changePassword: 'ChangePassword',
      SendOTP: 'SendOTP',
      ValidateOtp: 'ValidateOtp',
      GetAngularAppVersions: 'GetAngularAppVersions',
      GetBrandingConfigurationValue: 'GetBrandingConfigurationValue',
      getUserAccessDetails: 'getUserAccessDetails',
      userLoginPlatform: 'api/userloginPlatform',
    },
  },
  MainDashBoard: {
    endpoint: 'MainDashBoard/',
    methods: {
      GetDashBoardCarbonEmissionData: 'GetDashBoardCarbonEmissionData',
      GetDashBoardEmissionData: 'GetDashBoardEmissionData',
      GetCarbonEmissionDataByQuarterly: 'GetCarbonEmissionDataByQuarterly',
      GetAllKpiPreference: 'GetAllKpiPreference',
      AddOrUpdateKpiPreference: 'AddOrUpdateKpiPreference',
      GetEmployeeSatisfactionCountByType: 'GetEmployeeSatisfactionCountByType',
      GetBoardDiversityCountByGender: 'GetBoardDiversityCountByGender',
    },
  },
  Master: {
    endpoint: 'API/Master/',
    methods: {
      GetAllCountryMaster: 'GetAllCountryMaster',
      GetAllStateMaster: 'GetAllStateMaster',
      GetStateByCountryId: 'GetStateByCountryId',
      GetAllCityMaster: 'GetAllCityMaster',
      GetCityByStateId: 'GetCityByStateId',
      AddCityMaster: 'AddCityMaster',
      GetAllGender: 'GetAllGender',
      GetAllConfiguration: 'GetAllConfiguration',
      GetAllCategoryMaster: 'GetAllCategoryMaster',
      GetAllIndustryTypeBySectorAndDivison:
        'GetAllIndustryTypeBySectorAndDivison',
      GetAllModuleMaster: 'GetAllModuleMaster',
      GetAllSubModuleMaster: 'GetAllSubModuleMaster',
      GetAllUnitTypeMaster: 'GetAllUnitTypeMaster',
      GetAllUnitMaster: 'GetAllUnitMaster',
      GetAllUserTypeMaster: 'GetAllUserTypeMaster',
      GetAllDataCapturingFrequency: 'GetAllDataCapturingFrequency',
      GetReportingFrequencyMaster: 'GetReportingFrequencyMaster',
      GetAllProjectType: 'GetAllProjectType',
      GetAllLocation: 'GetAllLocation',
      GetDataCapturingSlotGroup: 'GetDataCapturingSlotGroup',
      GetSubModuleByModuleId: 'GetSubModuleByModuleId',
      GetCategoryByModuleAndSubModule: 'GetCategoryByModuleAndSubModule',
      GetAllModuleSubModuleMaster: 'GetAllModuleSubModuleMaster',
      GetDomain: 'GetDomain',
      GetConfigurationValue: 'GetConfigurationValue',
      UpdateConfigurationValue: 'UpdateConfigurationValue',
      AddAngularAppVersion: 'AddAngularAppVersion',
      GetAllPreviousReportingPeriodYear: 'GetAllPreviousReportingPeriodYear',
      FreezeTheReportingPeriodYear: 'FreezeTheReportingPeriodYear',
      GetAllEmailTransactionsAsync: 'GetAllEmailTransactionsAsync',
      GetReportingYearsAsync: 'GetReportingYearsAsync',
      GetAllReportingYearsMonthlyAsync: 'GetAllReportingYearsMonthlyAsync',
      GetAllJobTitleMaster: 'GetAllJobTitleMaster',
      DownloadDocument: 'DownloadDocument',
      GetEmployees: 'GetEmployees',
      GetOrganizationDetailsById: 'GetOrganizationDetailsById',
      GetAllExchangeMaster: 'GetAllExchangeMaster',
      GetAllCurrencyMaster: 'GetAllCurrencyMaster',
      AddorUpdateOrganizationDetails: 'AddorUpdateOrganizationDetails',
      GetAllIndustryClassificationFormat: 'GetAllIndustryClassificationFormat',
      AddBulkEmployesDeatils: 'AddBulkEmployesDeatils',
      GetAllEmployeeMaritalStatusTypeMaster:
        'GetAllEmployeeMaritalStatusTypeMaster',
      GetAllIndustryTypeByCorporateAndSiteOffice:
        'GetAllIndustryTypeByCorporateAndSiteOffice',
      GetAllIndustryDivisionBySector: 'GetAllIndustryDivisionBySector',
      GetAllEmployeeCategoryMaster: 'GetAllEmployeeCategoryMaster',
      GetCurrentCurrency: 'GetCurrentCurrency',
      GetAllUnitByTagId: 'GetAllUnitByTagId',
      GetAllUnitByTagsId: 'GetAllUnitByTagsId',
      GetBusinessEthicsChannelMaster: 'GetBusinessEthicsChannelMaster',
      GetBusinessEthicsStakeholderTypeMaster:
        'GetBusinessEthicsStakeholderTypeMaster',
      GetBusinessEthicsGrievanceTypeMaster:
        'GetBusinessEthicsGrievanceTypeMaster',
      GetBusinessEthicsGrievanceIssueTypeMaster:
        'GetBusinessEthicsGrievanceIssueTypeMaster',
      GetBusinessEthicsComplaintAgainstMaster:
        'GetBusinessEthicsComplaintAgainstMaster',
      GetBusinessEthicsNGBRCPrincipleTypeMaster:
        'GetBusinessEthicsNGBRCPrincipleTypeMaster',
      GetAllOfficeMaster: 'GetAllOfficeMaster',
      GetAllOfficeMasterWithUserAccess: 'GetAllOfficeMasterWithUserAccess',
      ActiveDeactiveReportingYear: 'ActiveDeactiveReportingYear',
      getEmissionStandardFactorsListAsync:
        'getEmissionStandardFactorsListAsync',
      GetAllTagsByTagTypeIds: 'GetAllTagsByTagTypeIds',
      AddDropdownOrSubDropdownItem: 'AddDropdownOrSubDropdownItem',
      GetEmissionStandardIdByLocation: 'GetEmissionStandardIdByLocation',
    },
  },
  materialityAssessment: {
    endpoint: 'MaterialityAssessment/',
    methods: {
      MaterialityAssessmentYears: 'MaterialityAssessmentYears', //get year list on main screen
      AddYear: 'AddYear', // to add year after year selection,
      MaterialityAssessmentYearList: 'MaterialityAssessmentYearList', ///get list on main screen
      TopicDomainMaster: 'TopicDomainMaster',
      CategoryMaster: 'CategoryMaster',
      AddTopicMaster: 'AddTopicMaster',
      Topic: 'Topic',
      GetSurveysListByYearId: 'GetSurveysListByYearId',
      AddStakeholder: 'AddStakeholder',
      GetStakeholders: 'GetStakeholders',
      GetSurveyById: 'GetSurveyById',
      GetTopicSelectionForSurvey: 'GetTopicSelectionForSurvey',
      StakeholderTypeMaster: 'StakeholderTypeMaster',
      SamplingMethodologyTypeMaster: 'SamplingMethodologyTypeMaster',
      RemoveSurveyStakeholderTopic: 'RemoveSurveyStakeholderTopic',
      RemoveMasurveyStakeholder: 'RemoveMasurveyStakeholder',
      SaveAndUpdate: 'SaveAndUpdate',
      AddSurveyByYearId: 'AddSurveyByYearId',
      GetIdentifiedTopics: 'GetIdentifiedTopics',
      MaterialityAssessmentSurveyList: 'MaterialityAssessmentSurveyList',
      AddTopic: 'AddTopic',
      RemoveTopic: 'RemoveTopic',
      GetByYearId: 'GetByYearId',
      UpdateOrAddSurveyResponses: 'UpdateOrAddSurveyResponses',
      PublishSurvey: 'PublishSurvey',
      SendNotification: 'SendNotification',
      GetSurveyLink: 'GetSurveyLink',
      DevelopmentGoal: 'DevelopmentGoal',
      GetYearTopicsAssesment: 'GetYearTopicsAssesment',
      UpdateOrInsertMASustainability: 'UpdateOrInsertMASustainability',
      UpdateMATopicMaster: 'UpdateMATopicMaster',
      UpdateYearStatusAsync: 'UpdateYearStatusAsync',
      GetTopicsForGraph: 'GetTopicsForGraph',
      GetTopicsForDoubleMaterialityAssessmentGraph:
        'GetTopicsForDoubleMaterialityAssessmentGraph',
      AddMaterialityDocument: 'AddMaterialityDocument',
      GetContentByYearId: 'GetContentByYearId',
      GetSurveyDetailsAsync: 'GetSurveyDetailsAsync',
      GetTopicImportanceAsync: 'GetTopicImportanceAsync',
      DownloadStakeholderTemplate: 'DownloadStakeholderTemplate',
      UploadExcelForStakeholder: 'UploadExcelForStakeholder',
      DeleteSASBDocument: 'DeleteSASBDocument',
      GetListTopicImportanceAsync: 'GetListTopicImportanceAsync',
      GetIMA: 'GetIMA',
      GetFMA: 'GetFMA',
      GetStakeholdersList: 'GetStakeholdersList',
      AddOrUpdateStakeholder: 'AddOrUpdateStakeholder',
    },
  },
  MaterialityAssessmentAnonymous: {
    endpoint: 'MaterialityAssessmentAnonymous/',
    methods: {
      GetSurveyDetailsAsync: 'GetSurveyDetailsAsync',
      UpdateOrAddSurveyResponses: 'UpdateOrAddSurveyResponses',
    },
  },
  Policy: {
    endpoint: 'Policy/',
    methods: {
      GetAllCustodianMasters: 'GetAllCustodianMasters',
      GetAllPolicyMasters: 'GetAllPolicyMasters',
      GetAllPolicyNameMaster: 'GetAllPolicyNameMaster',
      GetAllPolicyDocument: 'GetAllPolicyDocument',
      CreatePolicyVersion: 'CreatePolicyVersion',
      AddPolicyDocument: 'AddPolicyDocument',
      GetPolicyDocumentHistoryById: 'GetPolicyDocumentHistoryById',
      GetPolicyDocumentById: 'GetPolicyDocumentById',
      GetAllObsoleteDocuments: 'GetAllObsoleteDocuments',
      SetDocumentAsObsolete: 'SetDocumentAsObsolete',
      AddPolicyMaster: 'AddPolicyMaster',
      AddPolicyNameMaster: 'AddPolicyNameMaster',
    },
  },
  PollutionEmission: {
    endpoint: 'api/PollutionEmission/',
    methods: {
      AddOrUpdatePollutionEmission: 'AddOrUpdatePollutionEmission',
      GetAllPollutionEmissionData: 'GetAllPollutionEmissionData',
      GetAllPollutantTypeMaster: 'GetAllPollutantTypeMaster',
      GetInventoryByLocation: 'GetInventoryByLocation',
      DeletePollutionAirEmissionById: 'DeletePollutionAirEmissionById',
    },
  },
  RegionalOfficeMaster: {
    endpoint: 'RegionalOfficeMaster/',
    methods: {
      GetAllRegionalOfficeMaster: 'GetAllRegionalOfficeMaster',
      GetRegionalOfficeMasterById: 'GetRegionalOfficeMasterById',
      GetAllRegionalOfficeMasterByUserId: 'GetAllRegionalOfficeMasterByUserId',
      AddRegionalOfficeMaster: 'AddRegionalOfficeMaster',
      UpdateRegionalOfficeMaster: 'UpdateRegionalOfficeMaster',
      DeleteRegionalOfficeMasterById: 'DeleteRegionalOfficeMasterById',
      GetRegionalOfficeDropdown: 'GetRegionalOfficeDropdown',
    },
  },
  Report: {
    endpoint: 'API/Report/',
    methods: {
      //Dasboard
      GetReportTotalEmissionByScope: 'GetReportTotalEmissionByScope',
      //methods for GHR Emission All Scope
      GetReportScopeOne_ScopeTwoTotalEmissions:
        'GetReportScopeOne_ScopeTwoTotalEmissions',
      GetReportScopeOne_ScopeTwoTotalEmissionsByPercent:
        'GetReportScopeOne_ScopeTwoTotalEmissionsByPercent',
      GetReportTotalEmissionByScopeAndSiteLocation:
        'GetReportTotalEmissionByScopeAndSiteLocation',
      GetReportCombinedTotalEmissionByScopeAndRegionalOffice:
        'GetReportCombinedTotalEmissionByScopeAndRegionalOffice',

      //methods for GHR Emission scope1
      GetReportScope1_TotalEmissionBySiteLocation:
        'GetReportScope1_TotalEmissionBySiteLocation',
      GetReportScope1_TotalEmissionsBySitelocationPercent:
        'GetReportScope1_TotalEmissionsBySitelocationPercent',
      GetReportScope1_TotalEmissionsByRegionalLocation:
        'GetReportScope1_TotalEmissionsByRegionalLocation',
      GetReportScope1_TotalEmissionsByRegionalLocationPercent:
        'GetReportScope1_TotalEmissionsByRegionalLocationPercent',
      GetReportScope1_TotalEmissions: 'GetReportScope1_TotalEmissions',
      GetReportScope1_TotalEmissionsByFuelType:
        'GetReportScope1_TotalEmissionsByFuelType',
      GetReportScope1_TotalEmissionsByFuelTypePercent:
        'GetReportScope1_TotalEmissionsByFuelTypePercent',

      //methods for GHR Emission scope2

      GetReportScope2_TotalEmissionBySiteLocation:
        'GetReportScope2_TotalEmissionBySiteLocation',
      GetReportScope2_TotalEmissionsBySitelocationPercent:
        'GetReportScope2_TotalEmissionsBySitelocationPercent',
      GetReportScope2_TotalEmissionsByRegionalLocation:
        'GetReportScope2_TotalEmissionsByRegionalLocation',
      GetReportScope2_TotalEmissionsByRegionalLocationPercent:
        'GetReportScope2_TotalEmissionsByRegionalLocationPercent',
      GetReportScope2_TotalEmissions: 'GetReportScope2_TotalEmissions',
      GetReportScope2_TotalEmissionsByFuelType:
        'GetReportScope2_TotalEmissionsByFuelType',
      GetReportScope2_TotalEmissionsByFuelTypePercent:
        'GetReportScope2_TotalEmissionsByFuelTypePercent',

      //methods for GR Emission scope3
      GetReportScope3_TotalEmissionBySiteLocation:
        'GetReportScope3_TotalEmissionBySiteLocation',
      GetReportScope3_TotalEmissionsBySitelocationPercent:
        'GetReportScope3_TotalEmissionsBySitelocationPercent',
      GetReportScope3_TotalEmissionsByRegionalLocation:
        'GetReportScope3_TotalEmissionsByRegionalLocation',
      GetReportScope3_TotalEmissionsByRegionalLocationPercent:
        'GetReportScope3_TotalEmissionsByRegionalLocationPercent',
      GetReportScope3_TotalEmissionsByFuelType:
        'GetReportScope3_TotalEmissionsByFuelType',
      GetReportScope3_TotalEmissionsByFuelTypePercentVM:
        'GetReportScope3_TotalEmissionsByFuelTypePercentVM',
      GetReportScope3_TotalEmissionsByUpstreamAndDownstream:
        'GetReportScope3_TotalEmissionsByUpstreamAndDownstream',
      GetReportScope3_TotalEmissionsByUpstreamAndDownstreamInPercent:
        'GetReportScope3_TotalEmissionsByUpstreamAndDownstreamInPercent',
      GetReportScope3_TotalEmissionsByAllCategory:
        'GetReportScope3_TotalEmissionsByAllCategory',
      GetReportScope3_TotalEmissionsByCategory:
        'GetReportScope3_TotalEmissionsByCategory',
      GetReportScope3_TotalEmissionsByCategoryInPercent:
        'GetReportScope3_TotalEmissionsByCategoryInPercent',

      //avoidence
      GetReportTotalGHGAvoidanceEmissions:
        'GetReportTotalGHGAvoidanceEmissions',
      GetReportTotalAvoidanceEmissionByRegionalLocation:
        'GetReportTotalAvoidanceEmissionByRegionalLocation',
      GetReportTotalAvoidanceEmissionByRegionalLocationPercent:
        'GetReportTotalAvoidanceEmissionByRegionalLocationPercent',
      GetReportTotalAvoidanceEmissionByReportingPeriodByMonthly:
        'GetReportTotalAvoidanceEmissionByReportingPeriodByMonthly',
      GetReportTotalAvoidanceEmissionBySiteLocation:
        'GetReportTotalAvoidanceEmissionBySiteLocation',
      GetReportTotalAvoidanceEmissionBySiteLocationPercent:
        'GetReportTotalAvoidanceEmissionBySiteLocationPercent',
      GetReportTotalAvoidanceEmissionBySector:
        'GetReportTotalAvoidanceEmissionBySector',
      GetReportTotalAvoidanceEmissionBySectorInPercent:
        'GetReportTotalAvoidanceEmissionBySectorInPercent',
      GetReportTotalAvoidanceEmissionsByFuelType:
        'GetReportTotalAvoidanceEmissionsByFuelType',
      GetReportTotalAvoidanceEmissionsByFuelTypePercent:
        'GetReportTotalAvoidanceEmissionsByFuelTypePercent',
      GetBaselineyear: 'GetBaselineyear',
      GetAllOfficeMaster: 'GetAllOfficeMaster',
      GetDataCapturingSlotGroup: 'GetDataCapturingSlotGroup',
      GetAllReportDetails: 'GetAllReportDetails',
      GetAllSupplierCount: 'GetAllSupplierCount',
      GetInBoundAndOutBoundTransportation:
        'GetInBoundAndOutBoundTransportation',
      GetEmployeeTravelDetails: 'GetEmployeeTravelDetails',
      GetEmissionByGasType: 'GetEmissionByGasType',
      GetUnitByEmmployeeTravel: 'GetUnitByEmmployeeTravel',
      UnitConverter: 'UnitConverter',
      GetAllReportinPeriodYear: 'GetAllReportinPeriodYear',
      GetAllReportType: 'GetAllReportType',
      GetComparisonByLocationAndYear: 'GetComparisonByLocationAndYear',
      GetAllSubmduleList: 'GetAllSubmduleList',
      GetUserInfo: 'GetUserInfo',
      GetISOReportDetails: 'GetISOReportDetails',

      // Evidence
      GetEvidenceDataAsync: 'GetEvidenceDataAsync',
      GetEvidenceDocumentDataAsync: 'GetEvidenceDocumentDataAsync',
      DownloadFile: 'DownloadFile',

      GetBRSRDataAsync: 'GetBRSRDataAsync',
      AddOrUpdateBRSRDataAsync: 'AddOrUpdateBRSRDataAsync',
      AddUpdateReportDataWithLastAndSeconLastYearDataAsync:
        'AddUpdateReportDataWithLastAndSeconLastYearDataAsync',
      AddBRSRDocument: 'AddBRSRDocument',
      BRSRDocumentZips: 'BRSRDocumentZips',
      CSRDDocumentZips: 'CSRDDocumentZips',
      RemoveBRSRDocument: 'RemoveBRSRDocument',
      UpdateBRSRDocument: 'UpdateBRSRDocument',

      AddCSRYearDataAsync: 'AddCSRYearDataAsync',
      GetCSRDataAsync: 'GetCSRDataAsync',
      GetAllYearDataAsync: 'GetAllYearDataAsync',
      AddOrUpdateCSRDataAsync: 'AddOrUpdateCSRDataAsync',
      UpdateDocument: 'UpdateDocument',
      DeleteCSRDocument: 'DeleteCSRDocument',
      UpdateReportEditFlag: 'UpdateReportEditFlag',
      GetReportDataWithLastAndSeconLastYearDataAsync:
        'GetReportDataWithLastAndSeconLastYearDataAsync',

      // csrd
      GetCSRDReportDataAsync: 'GetCSRDReportDataAsync',
      AddOrUpdateCSRDReportingDataAsync: 'AddOrUpdateCSRDReportingDataAsync',
      AddCSRDReportingDocument: 'AddCSRDReportingDocument',
      GetAllCSRDTrainingTypemaster: 'GetAllCSRDTrainingTypemaster',
      GetAllCSRDAgeGroupTypeMaster: 'GetAllCSRDAgeGroupTypeMaster',
      GetAllCSRDCompliantTypeMaster: 'GetAllCSRDCompliantTypeMaster',
      DeleteCSRDDocument: 'DeleteCSRDDocument',
    },
  },
  ReportNotes: {
    endpoint: 'api/ReportNotes/',
    methods: {
      GetAllReportNotes: 'GetAllReportsNotes',
      AddOrUpdateReportNotes: 'AddOrUpdateReportNotes',
      DeleteReportNotes: 'DeleteReportNotes',
    },
  },
  SiteOfficeMaster: {
    endpoint: 'SiteOfficeMaster/',
    methods: {
      GetAllSiteOfficeMaster: 'GetAllSiteOfficeMaster',
      GetSiteOfficeMasterById: 'GetSiteOfficeMasterById',
      GetAllSiteOfficeMasterByRegionalOfficeId:
        'GetAllSiteOfficeMasterByRegionalOfficeId',
      AddSiteOfficeMaster: 'AddSiteOfficeMaster',
      UpdateSiteOfficeMaster: 'UpdateSiteOfficeMaster',
      DeleteSiteOfficeMasterById: 'DeleteSiteOfficeMasterById',
      GetSiteOfficeForDropdown: 'GetSiteOfficeForDropdown',
      GetSiteOfficeForDropdownByRegionalOfficeAccessIds:
        'GetSiteOfficeForDropdownByRegionalOfficeAccessIds',
    },
  },
  STPC: {
    endpoint: 'api/STPC/',
    methods: {
      GetAllModesOfStakeholderEngagementMasters:
        'GetAllModesOfStakeholderEngagementMasters',
      GetAllStakeholderTypeMasters: 'GetAllStakeholderTypeMasters',
      AddStakeholderTypeMasters: 'AddStakeholderTypeMasters',
      GetAllGrievanceTypeMasters: 'GetAllGrievanceTypeMasters',
      AddGrievanceTypeMasters: 'AddGrievanceTypeMasters',
      GetAllIssueMasters: 'GetAllIssueMasters',
      AddIssueTypeMasters: 'AddIssueTypeMasters',
      GetAllPolicyOnPoliticalContributionsMasters:
        'GetAllPolicyOnPoliticalContributionsMasters',
      GetAllModesOfContributionsMasters: 'GetAllModesOfContributionsMasters',
      GetSTPCByReportingYear: 'GetSTPCByReportingYear',
      AddOrUpdateSTPC: 'AddOrUpdateSTPC',
      DownloadtExcelTemplate: 'DownloadtExcelTemplate',
      uploadExcelForStakeholder: 'uploadExcelForStakeholder',
      AddOrUpdateStakeholder: 'AddOrUpdateStakeholder',
      GetStakeholdersList: 'GetStakeholdersList',
    },
  },
  Supplier: {
    endpoint: 'API/Supplier/',
    methods: {
      GetAllSupplierTypeMaster: 'GetAllSupplierTypeMaster',
      AddSupplierTypeMaster: 'AddSupplierTypeMaster',
      UpdateSupplierTypeMaster: 'UpdateSupplierTypeMaster',
      GetAllSupplierApplicationStatusMaster:
        'GetAllSupplierApplicationStatusMaster',
      GetAllSupplierQuestionCategoryMaster:
        'GetAllSupplierQuestionCategoryMaster',
      AddSupplierQuestionCategoryMaster: 'AddSupplierQuestionCategoryMaster',
      UpdateSupplierQuestionCategoryMaster:
        'UpdateSupplierQuestionCategoryMaster',
      GetAllSupplierList: 'GetAllSupplierList',
      GetSupplierListById: 'GetSupplierListById',
      AddSupplierlist: 'AddSupplierlist',
      UpdateSupplierlist: 'UpdateSupplierlist',
      GetAllSupplierQuestionMaster: 'GetAllSupplierQuestionMaster',
      GetDashboardRiskExposure: 'GetDashboardRiskExposure',
      UpdateSupplierApplicationStatus: 'UpdateSupplierApplicationStatus',
      IsAnExistingContact: 'IsAnExistingContact',
      IsAnExistingEmail: 'IsAnExistingEmail',
      DownloadExcelTemplateforSupplier: 'DownloadExcelTemplateforSupplier',
      UploadExcelForSupplier: 'UploadExcelForSupplier',
      GetSupplierCategory: 'GetSupplierCategory',
      RemoveSupplierOwnerAndSpoc: 'RemoveSupplierOwnerAndSpoc',
      RemoveSupplierDocument: 'RemoveSupplierDocument',
      LogEmailRequestSupplierQuestionnaire:
        'LogEmailRequestSupplierQuestionnaire',
      LogBulkEmailRequestSupplierQuestionnaire:
        'LogBulkEmailRequestSupplierQuestionnaire',
    },
  },
  SupplierAnonymous: {
    endpoint: 'SupplierAnonymous/',
    methods: {
      GetAllSupplierQuestions: 'GetAllSupplierQuestions',
      GetSupplierRemarkList: 'GetSupplierRemarkList',
      GetAllDocumentType: 'GetAllDocumentType',
      AddQuestionnaireDocument: 'AddQuestionnaireDocument',
      DeleteQuestionnaireDocument: 'DeleteQuestionnaireDocument',
      DeleteQuestionnaireSingleDocument: 'DeleteQuestionnaireSingleDocument',
      GetSupplierAllQuestionTxn: 'GetSupplierAllQuestionTxn',
      UpdateSupplierQuestionAnswer: 'UpdateSupplierQuestionAnswer',
      GetConfigurationValue: 'GetConfigurationValue',
    },
  },
  Tenant: {
    endpoint: `Tenant/`,
    methods: {
      AddTenant: 'AddTenant',
      GetAllTenant: 'GetAllTenant',
      GetTenant: 'GetTenant',
      GetTenantModuleAccess: 'GetTenantModuleAccess',
      AddTenantAccessModule: 'AddTenantAccessModule',
    },
  },
  TrainingAndDevelopment: {
    endpoint: `api/TrainingAndDevelopment/`,
    methods: {
      GetAllTrainingDetails: 'GetAllTrainingDetails',
      GetTrainingProgramMaster: 'GetTrainingProgramMaster',
      GetTraningTypeMaster: 'GetTraningTypeMaster',
      AddTraningTypeMaster: 'AddTraningTypeMaster',
      GetTrainingCategoryMaster: 'GetTrainingCategoryMaster',
      GetPostTrainingDocumentType: 'GetPostTrainingDocumentType',
      GetTrainingYearDetails: 'GetTrainingYearDetails',
      DownloadTrainingAttendeeExcel: 'DownloadTrainingAttendeeExcel',
      DeleteExcelUploadFile: 'DeleteExcelUploadFile',
      UploadTrainingAttendeeExcel: 'UploadTrainingAttendeeExcel',
      AddOrUpdateTrainingDetails: 'AddOrUpdateTrainingDetails',
      TotalEmployeeCountByLocationAndYear:
        'TotalEmployeeCountByLocationAndYear',
      AddPostTrainingDocument: 'AddPostTrainingDocument',
      DeletePostTrainingDocument: 'DeletePostTrainingDocument',
      DeleteTrainingDetails: 'DeleteTrainingDetails',
      DeleteTrainingCourse: 'DeleteTrainingCourse',
      GetEmployeeCountByType: 'GetEmployeeCountByType',
      GetTrainingOverview: 'getTrainingOverview',
    },
  },
  User: {
    endpoint: 'User/',
    methods: {
      GetAllUserMaster: 'GetAllUserMaster',
      AddUserDetail: 'AddUserDetail',
      UpdateUserDetail: 'UpdateUserDetail',
      ActiveDeactive: 'ActiveDeactive',
      ResetPasswordByEmailId: 'ResetPasswordByEmailId',
    },
  },
  UserAccessManagement: {
    endpoint: 'UserAccessManagement/',
    methods: {
      GetUserAccessManagementList: 'GetUserAccessManagementList',
      AddUserAccessModuleById: 'AddUserAccessModuleById',
      AddUserDetail: 'AddUserDetail',
      UpdateUserDetail: 'UpdateUserDetail',
      ActiveDeactive: 'ActiveDeactive',
      AddUserAccessModule: 'AddUserAccessModule',
      GetUserAccessModuleDetailsByUserId: 'GetUserAccessModuleDetailsByUserId',
    },
  },
  WeatherForecast: {
    endpoint: `WeatherForecast`,
  },
  WasteManagement: {
    endpoint: 'API/WasteManagement/',
    methods: {
      GetWasteData: 'GetWasteData',
      AddOrUpdateWasteManagement: 'AddOrUpdateWasteManagement',
      DeleteWasteManagementDocument: 'DeleteWasteManagementDocument',
    },
  },
  WaterManagement: {
    endpoint: 'WaterManagement/',
    methods: {
      GetWaterMGTSourceMaster: 'GetWaterMGTSourceMaster',
      GetWaterMGTSourceTypeMaster: 'GetWaterMGTSourceTypeMaster',
      GetAllWaterMGTStressLevelMasters: 'GetAllWaterMGTStressLevelMasters',
      GetAllWaterMgtdischargeDestinationMaster:
        'GetAllWaterMgtdischargeDestinationMaster',
      GetAllWaterMgtdischargeTreatmentLevelMaster:
        'GetAllWaterMgtdischargeTreatmentLevelMaster',
      WaterManagement: 'WaterManagement',
      GetWaterManagement: 'GetWaterManagement',
      DeleteWaterDischargeAndWithdrawals: 'DeleteWaterDischargeAndWithdrawals',
    },
  },
  OHS: {
    endpoint: 'api/OHS/',
    methods: {
      GetAllOHSEmployeeTypeMaster: 'GetAllOHSEmployeeTypeMaster',
      GetAllOhsIncidentTypeMaster: 'GetAllOhsIncidentTypeMaster',
      GetAllOhsSeverityLevelMaster: 'GetAllOhsSeverityLevelMaster',
      GetAllOhsResolutionStatusMaster: 'GetAllOhsResolutionStatusMaster',
      GetAllOhsStressLevelRatingMaster: 'GetAllOhsStressLevelRatingMaster',
      GetAllOhsWorkLifeBalanceRatingMaster:
        'GetAllOhsWorkLifeBalanceRatingMaster',
      GetAllOhsMedicalSupportMaster: 'GetAllOhsMedicalSupportMaster',
      GetAllOHSClassifyHCICriteriaMaster: 'GetAllOHSClassifyHCICriteriaMaster',
      GetAllOhsillnessDiseaseCategoryMaster:
        'GetAllOhsillnessDiseaseCategoryMaster',
      GetAllOhsResulationMaster: 'GetAllOhsStressLevelRatingMaster',
      AddOrUpdateEmployes: 'AddOrUpdateEmployes',
      AddOrUpdateOHSEmployes: 'AddOrUpdateEmployes',
      GetOHSInfromationEployeeById: 'GetOHSInfromationEployeeById',

      AddOrUpdateEmployesOHSData: 'AddOrUpdateEmployesOHSData',
      // Company info
      GetOHSCompanyById: 'GetOHSCompanyById',
      GetAllOhsCompanyHealthServicestMaster:
        'GetAllOhsCompanyHealthServicestMaster',
      GetAllOhsCompanyTrainingTypeMaster: 'GetAllOhsCompanyTrainingTypeMaster',
      AddOrUpdateCompanyHSData: 'AddOrUpdateCompanyHSData',

      DeleteOHSCompanyDocumentById: 'DeleteOHSCompanyDocumentById',
      OHSDeleteDocumentById: 'OHSDeleteDocumentById',
      GetAllInformationListEmployees: 'GetAllInformationListEmployees',
      GetOhsEmployeeInfromationById: 'GetOhsEmployeeInfromationById',
    },
  },

  EmployeeDetails: {
    endpoint: 'api/employeeDetails/',
    methods: {
      GetLocationList: 'GetLocationList',
      GetAllEhsInformationListEmployees: 'GetAllInformationListEmployees',
      GetEmployeeInfromationById: 'GetEmployeeInfromationById',
      GetAllEmployeeMaritalStatusTypeMaster:
        'GetAllEmployeeMaritalStatusTypeMaster',
      GetAllEmployeeDisabilityTypeMaster: 'GetAllEmployeeDisabilityTypeMaster',
      GetAllEmployeeEducationDetailsTypeMaster:
        'GetAllEmployeeEducationDetailsTypeMaster',
      GetAllEmploymentTypeMaster: 'GetAllEmploymentTypeMaster',
      GetAllEmployeeTypeMaster: 'GetAllEmployeeTypeMaster',
      GetAllEmploymentCategoryTypeMaster: 'GetAllEmploymentCategoryTypeMaster',
      GetAllEmployeeParentalLeaveTypeMaster:
        'GetAllEmployeeParentalLeaveTypeMaster',
      GetAllEmployeeReviewOutcomeMaster: 'GetAllEmployeeReviewOutcomeMaster',
      GetAllEmployeePromotionTypeMaster: 'GetAllEmployeePromotionTypeMaster',

      AddOrUpdateEmployes: 'AddOrUpdateEmployes',
      GetAllEmployeeWageMaster: 'GetAllEmployeeWageMaster',

      DownloadtExcelTemplateEmployee: 'DownloadtExcelTemplateEmployee',
      UploadExcelForEmployee: 'UploadExcelForEmployee',
      GetAllEmployeeCategoryMaster: 'GetAllEmployeeCategoryMaster',
      DeleteEmployeeDetails: 'DeleteEmployeeDetails',
    },
  },

  ProductRegistry: {
    endpoint: 'api/Product/',
    methods: {
      AddOrUpdateProductDetails: 'AddOrUpdateProductDetails',
      GetProductById: 'GetProductById',
      GetAllProducts: 'GetAllProducts',
      GetAllUnitByTag: 'GetAllUnitByTag',
      DeleteProductRoute: 'DeleteProductRoute',
    },
  },
};
